module.exports = __webpack_public_path__ + "static/media/closeEye.868f0c36.svg";